import { Link } from "react-router-dom";
import PropTypes from "prop-types";

const sanitiseUrl = path => {
  const url = new URL(path, "https://www.asos.com/");
  const { pathname, search } = url;

  return {
    pathname,
    search
  };
};

const SinglePageAppLink = ({ href, label, ...props }) => {
  const { pathname, search } = sanitiseUrl(href);

  return (
    <Link
      to={{
        pathname,
        search
      }}
      {...props}
    >
      {label}
    </Link>
  );
};

SinglePageAppLink.propTypes = {
  href: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default SinglePageAppLink;
